import { render } from "./ReportBugModal.vue?vue&type=template&id=12b6bb7f"
import script from "./ReportBugModal.vue?vue&type=script&lang=js"
export * from "./ReportBugModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__